import type { ReactNode } from "react";

import { Combobox } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { segmentStringBySearchTerm } from "app/pages/sales-intelligence/utils/strings";

import { StyledHighlightFragment } from "../StyledHighlightFragment";
import type { IGenericDropDownItem } from "../types";

/**
 * Option content for a multi-select SelectCombobox with search-term highlighting: the item's text
 * with matched fragments highlighted (matching the legacy CustomControlledMultiDropdown) plus a
 * right-aligned checkbox. Pass via `renderOption` with the current search term captured in a closure:
 * `renderOption={(item, isSelected) => renderHighlightedOption(item, isSelected, searchTerm)}`.
 */
export const renderHighlightedOption = (
    item: IGenericDropDownItem<string | number>,
    isSelected: boolean,
    searchTerm: string,
): ReactNode => {
    const fragments = segmentStringBySearchTerm(item.text ?? "", searchTerm);

    return (
        <Flex
            alignItems="center"
            justifyContent="space-between"
            gap="8px"
            width="100%"
        >
            <Combobox.OptionLabel>
                {fragments.map((fragment, index) => (
                    <StyledHighlightFragment
                        key={`${index}-${fragment.text}`}
                        $highlighted={fragment.highlighted}
                    >
                        {fragment.text}
                    </StyledHighlightFragment>
                ))}
            </Combobox.OptionLabel>
            <Combobox.OptionCheckbox isChecked={isSelected} />
        </Flex>
    );
};
